import { ref } from 'vue';

// Shared reactive state for the consultation popup.
// FooterZx toggles it open, ZxPopbox binds its visibility to it.
const visible = ref(false);

export function useConsultPopup() {
  function show() {
    visible.value = true;
  }

  function hide() {
    visible.value = false;
  }

  function toggle() {
    visible.value = !visible.value;
  }

  return { visible, show, hide, toggle };
}
